import type { SelectChangeEvent } from "@mui/material";
import { MenuItem, Select, Stack, Typography } from "@mui/material";
import type { EntityFieldType } from "../../../../../api/types/objectTypes";
import { fieldTypeCaptionMap } from "../../../../../utilities/enumCaptions";
import FieldIcon from "../../../../common/domain-icons/FieldIcon";
import { entityFieldTypesForUdf } from "./userDefinedFieldConfigurations";

interface Props {
  fieldType: EntityFieldType;
  onChange?: (fieldType: EntityFieldType) => void;
  disabled?: boolean;
  allowedFieldTypes?: readonly EntityFieldType[];
}

const Item = ({ fieldType }: { fieldType: EntityFieldType }) => (
  <Stack direction="row" spacing={1}>
    <FieldIcon fieldType={fieldType} color="action" />
    <Typography>{fieldTypeCaptionMap[fieldType]}</Typography>
  </Stack>
);

const FieldTypeSelect = ({ fieldType, onChange, disabled, allowedFieldTypes = entityFieldTypesForUdf }: Props) => {
  const handleChange = (e: SelectChangeEvent) => {
    if (!onChange) {
      return;
    }

    onChange(e.target.value as EntityFieldType);
  };

  return (
    <Select
      fullWidth
      disabled={disabled}
      value={fieldType}
      onChange={onChange ? handleChange : undefined}
      renderValue={(value) => <Item fieldType={value} />}
    >
      {allowedFieldTypes.map((type) => (
        <MenuItem key={type} value={type}>
          <Item fieldType={type} />
        </MenuItem>
      ))}
    </Select>
  );
};

export default FieldTypeSelect;
